export default "__VITE_ASSET__47fc230f__"